import { render, staticRenderFns } from "./oomDropdown.vue?vue&type=template&id=254c1858&scoped=true"
import script from "./oomDropdown.vue?vue&type=script&lang=js"
export * from "./oomDropdown.vue?vue&type=script&lang=js"
import style0 from "./oomDropdown.vue?vue&type=style&index=0&id=254c1858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c1858",
  null
  
)

export default component.exports